import React, { useEffect, useRef } from 'react';
import DomFont from '@jbhi-fi/lanyard-ui/font/DomFont';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';
// @ts-ignore
import { v4 as uuidv4 } from 'uuid';
import { loadExternalScript } from '@jbhi-fi/utils/src/loadExternalScript';
import { styles } from './PreezieFinder.css';
const PREEZIE_VERSION = '1.50.0';

export type PreezieFinderProps = {
  iconUrl?: string;
  title?: string;
  heading?: string;
  subText?: React.ReactNode;
  placement?: string;
  guideKey?: string;
  preezieUrl?: string;
};

export const PreezieFinder = ({
  iconUrl,
  title,
  heading,
  subText,
  placement,
  guideKey,
  preezieUrl = 'https://preeziecdn.azureedge.net/production/preguide.min.js',
}: PreezieFinderProps) => {
  const isBannerVisible = !!((title || heading || subText) && placement);
  const preezieElementId = useRef<string>(uuidv4());

  useEffect(() => {
    (() => {
      let shouldCancel = false;
      if (preezieUrl) {
        loadExternalScript(preezieUrl, () => {
          if (!shouldCancel) {
            window.PREEZIE_GUIDE?.render([
              {
                guideKey,
                version: PREEZIE_VERSION,
                renderTo: preezieElementId.current,
              },
            ]);
          }
        });
      }
      return () => (shouldCancel = true);
    })();
  }, []);

  const contents = (
    <div className={styles.preezieBannerOuter} id="finder-tool">
      {isBannerVisible ? (
        <div className={styles.preezieBanner}>
          {iconUrl ? (
            <div className={classNames([styles.finderIcon, styles.preezieBannerDiv])}>
              <img className={styles.finderIconImg} src={iconUrl} alt={`${title}Icon`} />
            </div>
          ) : null}
          <div className={classNames([styles.content, styles.preezieBannerDiv])}>
            {heading ? (
              <h3 className={styles.preezieBannerContentH3}>
                <DomFont>{heading}</DomFont>
              </h3>
            ) : null}
            {subText ? <div className={styles.preezieSubheadingText}>{subText}</div> : null}
          </div>
        </div>
      ) : null}
      <div className={styles.preezieWidgetContentContainer} id={preezieElementId.current}></div>
    </div>
  );
  return placement === 'Middle' ? <div className={styles.inlineTileWrapper}>{contents}</div> : contents;
};
